import React from 'react';
import { ChevronDown, Utensils } from 'lucide-react';
import { restaurantInfo } from '../data/mockData';
import { Badge } from './ui/badge';

export const Hero = () => {
  const scrollToMenu = (e) => {
    e.preventDefault();
    const menuSection = document.querySelector('#menu');
    if (menuSection) {
      const offset = 80;
      const elementPosition = menuSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1708388464878-5df2d66b758e?w=1920&q=80)'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/75"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="/planete-food-logo.png"
            alt="PLANETE FOOD Logo"
            className="w-[500px] md:w-[700px] lg:w-[800px] h-auto"
          />
        </div>

        {/* Tagline */}
        <p 
          className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {restaurantInfo.tagline}
        </p>

        {/* Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {restaurantInfo.badges.map((badge, index) => (
            <Badge
              key={index}
              variant="secondary"
              className="bg-[#D4A85F] text-black text-sm px-4 py-1.5 font-semibold"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              {badge}
            </Badge>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <a
            href="/traiteur"
            className="animate-vibrate inline-flex items-center gap-2 bg-[#D4A85F] text-black px-8 py-4 rounded-md font-bold text-lg hover:bg-[#E2B978] transition-all duration-200 hover:shadow-2xl w-full sm:w-auto justify-center"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            <Utensils size={20} />
            Service Traiteur
          </a>
          <a
            href="#menu"
            onClick={scrollToMenu}
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-white hover:text-black transition-all duration-200 hover:transform hover:-translate-y-1 w-full sm:w-auto justify-center"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Voir le menu
          </a>
        </div>

        {/* Quick Info */}
        <div className="text-white space-y-2">
          <div className="flex flex-col sm:flex-row justify-center gap-4 text-lg font-medium">
            {restaurantInfo.phones.map((phone, idx) => (
              <a 
                key={idx}
                href={phone.link} 
                className="hover:text-[#3ABEFF] transition-colors"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {phone.number}
              </a>
            ))}
          </div>
          <p 
            className="text-sm text-gray-300"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Lun-Ven: 11h–00h | Sam-Dim: 12h–00h • {restaurantInfo.openingNote}
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white" size={32} />
      </div>
    </section>
  );
};
